import React, { Component } from "react";

import {
  CButton,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";

class SelectModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      resources: [],
      methods: [],
      selected: null,
      // doc_id: null,
      type: "resource"
    };

    this.selectRowProp = {
      mode: "radio",
      bgColor: "#3399ff22", // you should give a bgcolor, otherwise, you can't regonize which row has been selected
      hideSelectColumn: true, // enable hide selection column.
      clickToSelect: true // you should enable clickToSelect, otherwise, you can't select column.
    };

    this.options = {
      onRowClick: row => this.onRowClick(row)
    };
  }

  onRowClick(row) {
    if (row.back === true) {
      this.setState({ selected: null });
    } else if (this.state.selected && row.id === this.state.selected.id) {
      this.setState({ selected: null });
    } else {
      this.setState({ selected: row });
    }
  }

  onRowDoubleClick(row) {
    if (row.folder) {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ doc_id: row.id });
    }
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    if (this.state.type === "resource") {
      this.setResource();
    } else {
      this.setMethod();
    }
  }

  setResource() {
    this.setState({ type: "resource", loading: true, selected: null });

    const id = this.props.group;

    axios
      .get(`${URL.api}education/resource/list`, {
        params: { group_id: id },
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ resources: resp.data.data, loading: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  setMethod() {
    this.setState({ type: "method", loading: true, selected: null });

    const id = this.props.group;

    axios
      .get(`${URL.api}education/method/list`, {
        params: { group_id: id },
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ methods: resp.data.data, loading: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    return (
      <CModal
        size="lg"
        show
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CDropdown className="d-inline-block">
            <CDropdownToggle color="white" className="p-0">
              <CModalTitle className="d-inline-block mr-1">
                {this.state.type === "resource" ? "Recursos" : "Métodos"}
              </CModalTitle>
            </CDropdownToggle>
            <CDropdownMenu
              placement="bottom"
              modifiers={[{ name: "flip", enabled: false }]}
            >
              <CDropdownItem onClick={() => this.setResource()}>
                Recursos
              </CDropdownItem>
              <CDropdownItem onClick={() => this.setMethod()}>
                Métodos
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </CModalHeader>
        <CModalBody
          className="p-0"
          style={{ maxHeight: "600px", overflow: "auto" }}
        >
          {this.state.loading ? (
            <div className="d-flex p-3 justify-content-center">
              <Loading />
            </div>
          ) : this.state.type === "resource" ? (
            this.state.resources.length > 0 ? (
              <BootstrapTable
                data={this.state.resources}
                selectRow={this.selectRowProp}
                options={this.options}
                tableStyle={{ border: 0 }}
                trClassName="cursor"
                hover
                version="4"
              >
                <TableHeaderColumn
                  isKey
                  className="d-none"
                  tdStyle={{ width: "1rem", border: 0, padding: "1.25rem" }}
                  dataField="id"
                  dataFormat={() => (
                    <i className="fa fa-puzzle-piece text-primary"></i>
                  )}
                >
                  Id
                </TableHeaderColumn>
                <TableHeaderColumn
                  className="d-none"
                  tdStyle={{ border: 0, padding: "1.25rem" }}
                  dataField="description"
                >
                  Descrição
                </TableHeaderColumn>
              </BootstrapTable>
            ) : (
              <div className="d-flex p-3 justify-content-center">
                <span className="text-center text-muted">
                  Nenhum recurso encontrado
                </span>
              </div>
            )
          ) : this.state.methods.length > 0 ? (
            <BootstrapTable
              data={this.state.methods}
              selectRow={this.selectRowProp}
              options={this.options}
              tableStyle={{ border: 0 }}
              trClassName="cursor"
              hover
              version="4"
            >
              <TableHeaderColumn
                isKey
                className="d-none"
                tdStyle={{ width: "1rem", border: 0, padding: "1.25rem" }}
                dataField="id"
                dataFormat={() => <i className="fa fa-gears text-warning"></i>}
              >
                Id
              </TableHeaderColumn>
              <TableHeaderColumn
                className="d-none"
                tdStyle={{ border: 0, padding: "1.25rem" }}
                dataField="description"
              >
                Descrição
              </TableHeaderColumn>
            </BootstrapTable>
          ) : (
            <div className="d-flex p-3 justify-content-center">
              <span className="text-center text-muted">
                Nenhum método encontrado
              </span>
            </div>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            disabled={this.state.selected === null}
            onClick={() =>
              this.props.onClose(this.state.selected, this.state.type)
            }
          >
            Selecionar
          </CButton>{" "}
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectModal);
